import { gql } from '@apollo/client';
import {
  ATTRUBUTE_BASIC_FRAGMENT,
  ATTRUBUTE_VALUE_BASIC_FRAGMENT,
} from './attributeFragments';
import { BRAND_BASIC_FRAGMENT } from './brandFragments';
import {
  CATEGORY_BASIC_FRAGMENT,
  CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT,
} from './categoryFragments';
import {
  PRODUCT_VARIANT_BASIC_FRAGMENT,
  PRODUCT_VARIANT_BASIC_TRASNLATIONS_FRAGMENT,
} from './productVariantFragments';

export const PRODUCT_BASIC_FRAGMENT = gql`
  fragment ProductBasic on Product {
    id
    name
    slug
    reviewsData
    description
    activeReviewsCount
    defaultTab
    seoTitle
    metaDescription
    translation(languageCode: $languageCode) {
      name
      description
    }
    brand {
      ...BrandBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
    category {
      ...CategoryTranslationBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
    rating
    isAvailable
    barcode
    thumbnail(size: 200) {
      url
      alt
    }
    attributes {
      attribute {
        ...AttributeBasic
        translation(languageCode: $languageCode) {
          name
        }
      }
      values {
        ...AttributeValueBasic
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
    attributesCategories {
      id
      name
      description
      translation(languageCode: $languageCode) {
        name
      }
    }
    reviews(first: 10) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      edges {
        node {
          id
          productVariant {
            id
            name
          }
          advantages
          disadvantages
          publishedAt
          rating
          status
        }
        cursor
      }
    }
    defaultVariant {
      ...ProductVariantTranslationsBasic
    }
    variants {
      ...ProductVariantTranslationsBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
    similarProducts(first: 10, filter: $similarProductsFilter) {
      edges {
        node {
          id
          name
          slug
          translation(languageCode: $languageCode) {
            name
          }
          defaultVariant {
            ...ProductVariantBasic
            translation(languageCode: $languageCode) {
              name
            }
          }
          variants {
            ...ProductVariantTranslationsBasic
            translation(languageCode: $languageCode) {
              name
            }
          }
        }
      }
    }
    similarProductsCategories {
      ...CategoryTranslationBasic
      translation(languageCode: $languageCode) {
        name
      }
    }
  }
  ${BRAND_BASIC_FRAGMENT}
  ${CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT}
  ${PRODUCT_VARIANT_BASIC_TRASNLATIONS_FRAGMENT}
  ${ATTRUBUTE_BASIC_FRAGMENT}
  ${ATTRUBUTE_VALUE_BASIC_FRAGMENT}
`;

export const SIMILAR_PRODUCTS_FRAGMENT = gql`
  fragment SimilarProduct on Product {
    id
    name
    slug
    reviewsData
    activeReviewsCount
    category {
      ...CategoryBasic
    }
    rating
    isAvailable
    barcode
    thumbnail(size: 200) {
      url
      alt
    }
    defaultVariant {
      ...ProductVariantBasic
    }
    variants {
      ...ProductVariantBasic
    }
    similarProducts(first: 10) {
      edges {
        node {
          id
          name
          slug
          defaultVariant {
            ...ProductVariantBasic
          }
        }
      }
    }
  }
  ${CATEGORY_BASIC_FRAGMENT}
  ${PRODUCT_VARIANT_BASIC_FRAGMENT}
`;

export const PRODUCT_WITH_DETAILS_FRAGMENT = gql`
  fragment ProductWithDetails on Product {
    ...ProductBasic
    description
    category {
      id
      name
    }
  }
  ${PRODUCT_BASIC_FRAGMENT}
`;
